






































import {
  Component,
  Vue,
  Prop,
  Watch
} from "@/shared/vuepack";
import {
  CommunicationEmployerGroup,
  EmployerTypeAheadResponse
} from "@/employer/types";
import _ from "lodash";
import { FetchState } from "@/shared/types";
import { useNotifierStore } from "@/shared/store/notifier";
import { usePartnerStore } from "@/employer/store/partner";

@Component({})
export default class CommunicationEmployerGroups extends Vue {
  notifierStore = useNotifierStore();
  partnerStore = usePartnerStore();

  @Prop({ required: true })
  value: CommunicationEmployerGroup[];

  @Prop()
  partnerId: number;

  @Prop()
  isEmployerExclusionList: boolean;

  FetchState = FetchState;
  pageSize = 10;
  searchTerm = "";
  suggestions = [];
  selectedUnassignedEmployerGroup: CommunicationEmployerGroup = null;
  selectedAssignedEmployerGroups = [];
  isDirty = false;
  selectedEmployer = null;
  selectionChanged = false;
  autoFocus = false;
  debouncedSearch = _.debounce((searchTerm, partnerId) => this.fetchEmployerList({
    partnerId,
    searchTerm
  }), 600);

  get noRecordsFound () {
    if (this.partnerStore.employerSearchTypeAheadResult &&
        this.partnerStore.employerSearchTypeAheadFetchState === FetchState.Loaded &&
        this.searchTerm !== "" && !this.isDirty) {
      return this.partnerStore.employerSearchTypeAheadResult.employers.length === 0;
    }
    return false;
  }

  get employerIds () {
    return this.value.sort((a, b) => a.name.localeCompare(b.name)).map(t => {
      return {
        value: t,
        text: this.employerFormatString(t),
      };
    });
  }

  get employerAlreadyAssigned () {
    return (this.selectedUnassignedEmployerGroup && this.selectedUnassignedEmployerGroup.id &&
        this.value.find(t => t.id === this.selectedUnassignedEmployerGroup.id) !== undefined);
  }

  get addDisabled () {
    if (this.selectedUnassignedEmployerGroup && this.selectedUnassignedEmployerGroup.id) {
      return this.employerAlreadyAssigned;
    }
    return true;
  }

  get removeDisabled () {
    return this.selectedAssignedEmployerGroups && this.selectedAssignedEmployerGroups.length === 0;
  }
  get getLabelForAssignedGroup () {
    if (this.isEmployerExclusionList) {
      return "Excluded employer groups";
    }
    return "Included employer groups";
  }
  @Watch("value")
  valueChanged () {
    this.selectedUnassignedEmployerGroup = null;
    this.selectedAssignedEmployerGroups = [];
  }

  @Watch("partnerStore.employerSearchTypeAheadResult", { deep: true })
  updateEmployersSuggestions () {
    if (this.partnerStore.employerSearchTypeAheadResult) {
      this.suggestions = this.partnerStore.employerSearchTypeAheadResult.employers;
    }
    this.isDirty = false;
  }

  showError (message: string): void {
    this.notifierStore.setDanger(message);
  }

  handleError (err: any): void {
    this.showError(
        (err && err.errorMessage) ||
        "Error processing your request. Please try again later"
    );
  }

  handleSelectionChanged (value) {
    this.selectedEmployer = value;
    this.selectionChanged = true;
    this.selectedUnassignedEmployerGroup = { ...value };
  }

  @Watch("searchTerm")
  onSearchTermChange (searchValue): void {
    if (this.selectedEmployer) {
      if (this.selectionChanged) {
        this.selectionChanged = false;
        return;
      }
      this.selectedEmployer = null;
      this.$emit("select-employer", null);
    }
    this.isDirty = true;
    this.debouncedSearch(searchValue, this.partnerId);
  }

  fetchEmployerList (data: { partnerId: number, searchTerm: string }): void {
    if (data.searchTerm.length >= 3) {
      this.partnerStore.getEmployerSearchTypeAhead(data).catch(this.handleError);
    }
  }

  employerFormatString (employer) {
    if (employer.code && employer.code !== "") {
      return `${employer.code} | ${employer.name}`;
    }
    return employer.name;
  }

  addSelected () {
    this.$emit("input", [ ...this.value, this.selectedUnassignedEmployerGroup ]);
    setTimeout(() => {
      this.searchTerm = "";
      if (this.autoFocus) {
        this.handleFocus();
        this.autoFocus = false;
      }
    });
  }

  removeSelected () {
    this.$emit("input",
        [ ...this.value ].filter(v => !this.selectedAssignedEmployerGroups.map(t => t.id).includes(v.id)));
  }

  doubleClickSelected (e) {
    if (e.target.nodeName === "OPTION" || e.target.nodeName === "SELECT") {
      this.removeSelected();
    }
  }

  handleFocus (focusOverride = false) {
    const typeaheadRef = this.$refs.typeahead as any;
    typeaheadRef.$refs.input.focus();
    if (focusOverride) {
      typeaheadRef.isFocused = false;
    }
  }

  handleKeyUp (event) {
    if (event.code === "Enter") {
      if (this.selectedUnassignedEmployerGroup) {
        if (!this.employerAlreadyAssigned) {
          this.autoFocus = true;
          this.addSelected();
        } else {
          setTimeout(() => {
            this.handleFocus(true);
          });
        }
      }
    }
  }
}
